export const faqPartyPPI = `
<html
    ><head
        ><meta
            content="text/html; charset=UTF-8"
            http-equiv="content-type" /><style type="text/css">
            @import url(https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI);
          .lst-kix_itvhenjdxo0x-2 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_itvhenjdxo0x-0 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_itvhenjdxo0x-4 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_12p1xbbo9f2l-7 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_itvhenjdxo0x-3 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_itvhenjdxo0x-6 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_12p1xbbo9f2l-8 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_itvhenjdxo0x-5 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_12p1xbbo9f2l-2 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_qo1umdo4ia5b-8 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_ptoei02p70xh-7 > li:before {
                content: "\\0025cb   ";
            }
            ul.lst-kix_12p1xbbo9f2l-0 {
                list-style-type: none;
            }
            .lst-kix_12p1xbbo9f2l-3 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_12p1xbbo9f2l-6 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_ptoei02p70xh-5 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_ptoei02p70xh-6 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_qo1umdo4ia5b-6 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_12p1xbbo9f2l-4 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_ptoei02p70xh-4 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_12p1xbbo9f2l-5 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_itvhenjdxo0x-1 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_qo1umdo4ia5b-7 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_ptoei02p70xh-1 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_ptoei02p70xh-2 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_ptoei02p70xh-3 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_ptoei02p70xh-0 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_bfu32f7ijbb2-1 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_bfu32f7ijbb2-2 > li:before {
                content: "\\0025a0   ";
            }
            ul.lst-kix_qo1umdo4ia5b-0 {
                list-style-type: none;
            }
            ul.lst-kix_qo1umdo4ia5b-1 {
                list-style-type: none;
            }
            ul.lst-kix_qo1umdo4ia5b-2 {
                list-style-type: none;
            }
            .lst-kix_bfu32f7ijbb2-3 > li:before {
                content: "\\0025cf   ";
            }
            ul.lst-kix_qo1umdo4ia5b-3 {
                list-style-type: none;
            }
            ul.lst-kix_qo1umdo4ia5b-4 {
                list-style-type: none;
            }
            ul.lst-kix_qo1umdo4ia5b-5 {
                list-style-type: none;
            }
            ul.lst-kix_itvhenjdxo0x-2 {
                list-style-type: none;
            }
            ul.lst-kix_qo1umdo4ia5b-6 {
                list-style-type: none;
            }
            .lst-kix_bfu32f7ijbb2-5 > li:before {
                content: "\\0025a0   ";
            }
            .lst-kix_bfu32f7ijbb2-6 > li:before {
                content: "\\0025cf   ";
            }
            ul.lst-kix_itvhenjdxo0x-3 {
                list-style-type: none;
            }
            ul.lst-kix_qo1umdo4ia5b-7 {
                list-style-type: none;
            }
            ul.lst-kix_itvhenjdxo0x-4 {
                list-style-type: none;
            }
            ul.lst-kix_qo1umdo4ia5b-8 {
                list-style-type: none;
            }
            ul.lst-kix_itvhenjdxo0x-5 {
                list-style-type: none;
            }
            ul.lst-kix_itvhenjdxo0x-6 {
                list-style-type: none;
            }
            .lst-kix_bfu32f7ijbb2-4 > li:before {
                content: "\\0025cb   ";
            }
            ul.lst-kix_itvhenjdxo0x-7 {
                list-style-type: none;
            }
            ul.lst-kix_itvhenjdxo0x-8 {
                list-style-type: none;
            }
            .lst-kix_bfu32f7ijbb2-7 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_bfu32f7ijbb2-8 > li:before {
                content: "\\0025a0   ";
            }
            ul.lst-kix_ptoei02p70xh-1 {
                list-style-type: none;
            }
            ul.lst-kix_ptoei02p70xh-2 {
                list-style-type: none;
            }
            ul.lst-kix_ptoei02p70xh-3 {
                list-style-type: none;
            }
            ul.lst-kix_ptoei02p70xh-4 {
                list-style-type: none;
            }
            .lst-kix_qo1umdo4ia5b-0 > li:before {
                content: "\\0025cf   ";
            }
            .lst-kix_qo1umdo4ia5b-2 > li:before {
                content: "\\0025a0   ";
            }
            ul.lst-kix_ptoei02p70xh-5 {
                list-style-type: none;
            }
            ul.lst-kix_ptoei02p70xh-6 {
                list-style-type: none;
            }
            ul.lst-kix_ptoei02p70xh-7 {
                list-style-type: none;
            }
            ul.lst-kix_ptoei02p70xh-8 {
                list-style-type: none;
            }
            .lst-kix_qo1umdo4ia5b-1 > li:before {
                content: "\\0025cb   ";
            }
            .lst-kix_qo1umdo4ia5b-5 > li:before {
                content: "\\0025a0   ";
            }
            ul.lst-kix_bfu32f7ijbb2-4 {
                list-style-type: none;
            }
            ul.lst-kix_12p1xbbo9f2l-3 {
                list-style-type: none;
            }
            ul.lst-kix_bfu32f7ijbb2-3 {
                list-style-type: none;
            }
            ul.lst-kix_12p1xbbo9f2l-4 {
                list-style-type: none;
            }
            ul.lst-kix_bfu32f7ijbb2-2 {
                list-style-type: none;
            }
            ul.lst-kix_12p1xbbo9f2l-1 {
                list-style-type: none;
            }
            ul.lst-kix_bfu32f7ijbb2-1 {
                list-style-type: none;
            }
            ul.lst-kix_12p1xbbo9f2l-2 {
                list-style-type: none;
            }
            .lst-kix_qo1umdo4ia5b-4 > li:before {
                content: "\\0025cb   ";
            }
            ul.lst-kix_bfu32f7ijbb2-8 {
                list-style-type: none;
            }
            .lst-kix_12p1xbbo9f2l-0 > li:before {
                content: "\\0025cf   ";
            }
            ul.lst-kix_12p1xbbo9f2l-7 {
                list-style-type: none;
            }
            ul.lst-kix_bfu32f7ijbb2-7 {
                list-style-type: none;
            }
            ul.lst-kix_12p1xbbo9f2l-8 {
                list-style-type: none;
            }
            li.li-bullet-0:before {
                margin-left: -18pt;
                white-space: nowrap;
                display: inline-block;
                min-width: 18pt;
            }
            ul.lst-kix_bfu32f7ijbb2-6 {
                list-style-type: none;
            }
            .lst-kix_12p1xbbo9f2l-1 > li:before {
                content: "\\0025cb   ";
            }
            ul.lst-kix_12p1xbbo9f2l-5 {
                list-style-type: none;
            }
            .lst-kix_ptoei02p70xh-8 > li:before {
                content: "\\0025a0   ";
            }
            ul.lst-kix_bfu32f7ijbb2-5 {
                list-style-type: none;
            }
            ul.lst-kix_12p1xbbo9f2l-6 {
                list-style-type: none;
            }
            ul.lst-kix_ptoei02p70xh-0 {
                list-style-type: none;
            }
            .lst-kix_qo1umdo4ia5b-3 > li:before {
                content: "\\0025cf   ";
            }
            ul.lst-kix_bfu32f7ijbb2-0 {
                list-style-type: none;
            }
            .lst-kix_itvhenjdxo0x-8 > li:before {
                content: "\\0025a0   ";
            }
            ul.lst-kix_itvhenjdxo0x-0 {
                list-style-type: none;
            }
            .lst-kix_itvhenjdxo0x-7 > li:before {
                content: "\\0025cb   ";
            }
            ul.lst-kix_itvhenjdxo0x-1 {
                list-style-type: none;
            }
            .lst-kix_bfu32f7ijbb2-0 > li:before {
                content: "\\0025cf   ";
            }
            ol {
                margin: 0;
                padding: 0;
            }
            table td,
            table th {
                padding: 0;
            }
            .c10 {
                color: #434343;
                font-weight: 400;
                text-decoration: none;
                vertical-align: baseline;
                font-size: 12pt;
                font-family: "Arial";
                font-style: normal;
            }
            .c4 {
                color: #000000;
                font-weight: 700;
                text-decoration: none;
                vertical-align: baseline;
                font-size: 18pt;
                font-family: "Roboto";
                font-style: normal;
            }
            .c3 {
                padding-top: 4pt;
                padding-bottom: 4pt;
                line-height: 1.15;
                page-break-after: avoid;
                orphans: 2;
                widows: 2;
                text-align: justify;
            }
            .c1 {
                color: #000000;
                font-weight: 400;
                text-decoration: none;
                vertical-align: baseline;
                font-size: 12pt;
                font-family: "Roboto";
                font-style: normal;
            }
            .c0 {
                color: #434343;
                font-weight: 600;
                text-decoration: none;
                vertical-align: baseline;
                font-size: 13pt;
                font-family: "Roboto";
                font-style: normal;
            }
            .c2 {
                padding-top: 0pt;
                padding-bottom: 4pt;
                line-height: 1.15;
                orphans: 2;
                widows: 2;
                text-align: justify;
            }
            .c8 {
                padding-top: 0pt;
                padding-bottom: 12pt;
                line-height: 1.15;
                orphans: 2;
                widows: 2;
                text-align: center;
            }
            .c9 {
                background-color: #ffffff;
            }
            .c6 {
                margin-left: 36pt;
                padding-left: 0pt;
            }
            .c7 {
                padding: 0;
                margin: 0;
            }
            .c5 {
                height: 11pt;
            }
            .title {
                padding-top: 0pt;
                color: #000000;
                font-size: 26pt;
                padding-bottom: 3pt;
                font-family: "Arial";
                line-height: 1.15;
                page-break-after: avoid;
                orphans: 2;
                widows: 2;
                text-align: left;
            }
            .subtitle {
                padding-top: 0pt;
                color: #666666;
                font-size: 15pt;
                padding-bottom: 16pt;
                font-family: "Arial";
                line-height: 1.15;
                page-break-after: avoid;
                orphans: 2;
                widows: 2;
                text-align: left;
            }
            li {
                color: #000000;
                font-size: 11pt;
                font-family: "Arial";
            }
        </style></head
    ><body class="c9 doc-content"
        ><p class="c8"><span class="c4">Birthday Party FAQ</span></p
        ><h3 class="c3" id="h.r15xqhqdkim2"
            ><span class="c0">1. When can I book a birthday party?</span></h3
        ><p class="c2"
            ><span class="c1"
                >Reservations for regular birthday parties must be made at least
                3 days before the event. Bookings with shorter notice may still
                be accommodated depending on schedule availability.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.1vbszjgxtuwf"
            ><span class="c0">2. How many pax included per package? </span></h3
        ><p class="c2"
            ><span class="c1"
                >Minimum of 20 children and 20 companions, with an additional 10
                immediate family members. Packages can be multiplied
                accordingly.</span
            ></p
        ><p class="c2 c5"><span class="c1"></span></p><hr /><p class="c2 c5"
            ><span class="c1"></span></p
        ><h3 class="c3" id="h.8plk8fgqx34u"
            ><span class="c0"
                >3. Are the birthday child and parents included in the
                package?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >Yes, the birthday child and parents are included in the
                selected birthday package quota.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.mh7mibl2vhpk"
            ><span class="c0"
                >4. Is a deposit (DP) allowed, or is full payment
                required?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >We do not accept deposits. Full payment is required once the
                reservation is confirmed to secure your preferred time
                slot.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.alx3tz51x0pq"
            ><span class="c0"
                >5. What is the cancellation and refund policy?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >Confirmed reservations are non-refundable.<br />For
                rescheduling, please contact our Guest Experience Team to check
                availability.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.1ucbrxhbz0kg"
            ><span class="c0">6. Are there any additional charges?</span></h3
        ><p class="c2"
            ><span class="c1"
                >Yes, the birthday child and parents are included in the
                selected birthday package quota, and &nbsp;if the playtime
                exceeds the time limit.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.3uue652ikrnm"
            ><span class="c0"
                >7. When should birthday details (guest list, decorations, etc.)
                be submitted?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >All birthday details (guest list, decoration requirements, and
                other information) must be submitted at least 4 days before the
                event to ensure proper preparation.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.hvtvl2nfhr8c"
            ><span class="c0"
                >8. Can I bring outside food, drinks, and decorations?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >Yes, outside food, drinks, and decorations are allowed. Please
                read Terms and Conditions before payment.
            </span></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.pccyq8cjr4e"
            ><span class="c0"
                >9. What is the minimum age requirement for children to enter
                the playground?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >Recommended for children aged 1&ndash;6 years, including one
                companion.</span
            ></p
        ><p class="c2 c5"><span class="c1"></span></p><hr /><p class="c2 c5"
            ><span class="c1"></span></p
        ><h3 class="c3" id="h.fhytsqqd318f"
            ><span class="c0"
                >10. Are anti-slip socks required during the birthday
                event?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >Yes, all children must wear anti-slip socks.<br />Companions
                may wear regular socks.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.c7qixuwxt0g0"
            ><span class="c0"
                >11. Are guests or companions allowed to play?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >Guests are allowed to accompany children in the play area and
                join the celebration in the party room.<br />All must wear
                anti-slip socks.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.di51m44xog5v"
            ><span class="c0"
                >12. Who are considered &ldquo;guests&rdquo; in the birthday
                package?</span
            ></h3
        ><ul class="c7 lst-kix_12p1xbbo9f2l-0 start"
            ><li class="c2 c6 li-bullet-0"
                ><span class="c1"
                    >SPI &amp; SPURI:<br />Guests refer to parents or companions
                    attending the birthday event.</span
                ></li
            ></ul
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.3n7fd67lv9b"
            ><span class="c0"
                >13. What is the recommended arrival time?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >Guests are advised to arrive 30 minutes before the event for
                preparation in the party room.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.ywm7e264lbn9"
            ><span class="c0"
                >14. What activities are included in the 3-hour birthday
                party?</span
            ></h3
        ><p class="c2"
            ><span class="c1">During the 3-hour session, guests can:</span></p
        ><ul class="c7 lst-kix_itvhenjdxo0x-0 start"
            ><li class="c2 c6 li-bullet-0"
                ><span class="c1">Play in the playground area</span></li
            ><li class="c2 c6 li-bullet-0"
                ><span class="c1">Celebrate in the party room</span></li
            ></ul
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.jzorjrwipdws"
            ><span class="c0"
                >15. What is the role of the MC during the event?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >The MC will accompany the event for 1 hour, assisting and
                guiding the birthday celebration.</span
            ></p
        ><hr /><p class="c2 c5"><span class="c1"></span></p
        ><h3 class="c3" id="h.bq4lhpglfi6t"
            ><span class="c0"
                >16. Can additional pax be added on the event day?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >Yes, additional pax can be added.<br />Payment can be completed
                at the ticketing counter after the event ends.</span
            ></p
        ><p class="c2 c5"><span class="c1"></span></p><hr /><p class="c2 c5"
            ><span class="c1"></span></p
        ><h3 class="c3" id="h.fvv6brad4us3"
            ><span class="c0"
                >17. When will the e-Invitation be sent?</span
            ></h3
        ><p class="c2"
            ><span class="c1"
                >The e-Invitation will be sent after the payment has been fully
                completed.</span
            ></p
        ><p class="c2 c5"><span class="c4"></span></p
        ><p class="c2 c5"><span class="c4"></span></p
        ><p class="c2 c5"><span class="c1"></span></p></body
></html>

`;
